export default __webpack_public_path__ + "static/media/letterB.17484165.svg";